import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const HelpTab = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <HelpCircle className="w-5 h-5 text-primary" />
          Kullanım Kılavuzu
        </CardTitle>
        <CardDescription>
          Ana sayfa yönetimi hakkında detaylı bilgi
        </CardDescription>
      </CardHeader>
      <CardContent className="prose prose-sm max-w-none">
        <Accordion type="single" collapsible className="w-full">
          <AccordionItem value="banner">
            <AccordionTrigger>Üst Banner Nasıl Düzenlenir?</AccordionTrigger>
            <AccordionContent>
              <div className="space-y-2 text-sm text-muted-foreground">
                <p><strong>Üst Banner</strong>, ana sayfanın en üstünde görünen kampanya şerididir.</p>
                <ul className="list-disc pl-4 space-y-1">
                  <li><strong>Dönen Slogan Yazı 1 / Yazı 2:</strong> Türkçe yazın; 4 saniyede bir yanıp sönerek değişir</li>
                  <li><strong>Bannerı Diğer Dillere Çevir:</strong> Türkçe metinleri EN/DE/FR/AR vb. dillere otomatik çevirir ve kaydeder</li>
                  <li><strong>Sabit metin:</strong> &quot;YETERKİ SEN ÜRET TÜRKİYE&quot; her zaman sağda sabit kalır</li>
                  <li><strong>Buton Metni / Link:</strong> Tıklanacak yazı ve URL</li>
                </ul>
                <p className="mt-2"><strong>İpucu:</strong> Metni değiştirdikten sonra mutlaka &quot;Bannerı Diğer Dillere Çevir&quot;e basın; yoksa diğer dillerde eski/Türkçe kalır.</p>
              </div>
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="flash">
            <AccordionTrigger>Flaş İndirimler Bölümü</AccordionTrigger>
            <AccordionContent>
              <div className="space-y-2 text-sm text-muted-foreground">
                <p><strong>Flaş İndirimler</strong>, ana sayfanın hero bölümüdür.</p>
                <ul className="list-disc pl-4 space-y-1">
                  <li><strong>Başlık ve Alt Başlık:</strong> Bölüm başlıkları</li>
                  <li><strong>Geri Sayım:</strong> Kampanya bitiş süresi (saat)</li>
                  <li><strong>Ürün Sayısı:</strong> Gösterilecek ürün adedi (3-12)</li>
                </ul>
                <p className="mt-2">Ürünler otomatik olarak her kategoriden seçilir. Öne çıkan olarak işaretlenen ürünler önceliklidir.</p>
              </div>
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="categories">
            <AccordionTrigger>Kategori Kartları</AccordionTrigger>
            <AccordionContent>
              <div className="space-y-2 text-sm text-muted-foreground">
                <p><strong>Kategori Kartları</strong>, yatay kaydırmalı kategori bölümüdür.</p>
                <ul className="list-disc pl-4 space-y-1">
                  <li><strong>İsim:</strong> Kategori adı</li>
                  <li><strong>Link:</strong> Tıklandığında gidilecek sayfa</li>
                  <li><strong>Resim URL:</strong> Kart arka plan resmi (200x200 önerilir)</li>
                  <li><strong>Renk:</strong> Overlay rengi</li>
                  <li><strong>Aktif/Pasif:</strong> Kartı göster/gizle</li>
                </ul>
                <p className="mt-2"><strong>Resim Önerisi:</strong> Unsplash veya Pexels&apos;ten ücretsiz resimler kullanabilirsiniz.</p>
              </div>
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="brands">
            <AccordionTrigger>Marka Vitrini</AccordionTrigger>
            <AccordionContent>
              <div className="space-y-2 text-sm text-muted-foreground">
                <p><strong>Marka Vitrini</strong>, popüler markaları gösteren bölümdür.</p>
                <ul className="list-disc pl-4 space-y-1">
                  <li><strong>Marka Adı:</strong> Gösterilecek marka ismi</li>
                  <li><strong>Logo:</strong> Emoji veya karakter</li>
                  <li><strong>İndirim:</strong> İndirim yüzdesi (örn: %20)</li>
                  <li><strong>Marka Ekle:</strong> Yeni marka eklemek için butonu kullanın</li>
                  <li><strong>Marka Sil:</strong> Kartın üzerine gelip X&apos;e tıklayın</li>
                </ul>
              </div>
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="banners">
            <AccordionTrigger>Kampanya Bannerları</AccordionTrigger>
            <AccordionContent>
              <div className="space-y-2 text-sm text-muted-foreground">
                <p><strong>Kampanya Bannerları</strong>, iki sütunlu büyük görsel bannerlarıdır.</p>
                <ul className="list-disc pl-4 space-y-1">
                  <li><strong>Başlık:</strong> Banner ana başlığı</li>
                  <li><strong>Alt Başlık:</strong> Açıklama metni</li>
                  <li><strong>Badge:</strong> Sol üst köşedeki etiket</li>
                  <li><strong>Resim URL:</strong> Arka plan resmi (800x400 önerilir)</li>
                  <li><strong>Link:</strong> Tıklandığında gidilecek sayfa</li>
                </ul>
                <p className="mt-2">Resimler gradient overlay ile kaplanır, bu nedenle açık renkli resimler önerilir.</p>
              </div>
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="tips">
            <AccordionTrigger>Genel İpuçları</AccordionTrigger>
            <AccordionContent>
              <div className="space-y-2 text-sm text-muted-foreground">
                <ul className="list-disc pl-4 space-y-2">
                  <li><strong>Önizleme:</strong> Değişikliklerinizi kaydetmeden önce Önizle butonuyla kontrol edin</li>
                  <li><strong>Kaydetme:</strong> Tüm değişiklikler Kaydet butonuna basılana kadar geçici kalır</li>
                  <li><strong>Sıfırlama:</strong> Hata yaparsanız Sıfırla ile varsayılan ayarlara dönün</li>
                  <li><strong>Resim URL&apos;leri:</strong> Harici resim servisleri (Unsplash, Pexels) veya kendi sunucunuzu kullanabilirsiniz</li>
                  <li><strong>Mobil Uyumluluk:</strong> Tüm bölümler otomatik olarak mobil uyumludur</li>
                </ul>
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>

        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
          <h4 className="font-semibold text-blue-900 mb-2">Video Kılavuz</h4>
          <p className="text-sm text-blue-700">
            Detaylı video kılavuz için destek ekibimizle iletişime geçin: <strong>destek@turkishemarket.com</strong>
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default HelpTab;
